var map = {
	"./new_h_variant_1.json": [
		94809,
		4809
	],
	"./new_h_variant_2.json": [
		74521,
		4521
	],
	"./new_h_variant_3.json": [
		78187,
		3669
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 23355;
module.exports = webpackAsyncContext;